import React, {useState, useEffect} from 'react'
import Banner from '../../Components/Banner'
import { Image } from '../../Components/Rooms'
import { gallery2 } from '../../Constants/gallery'
import Masonry from 'react-masonry-css'
import { useTranslation } from 'react-i18next';
interface Category {
    name : string
    value: string
}

const categories = [
    {name : 'hotel', value: 'hotel'},
    {name : 'landscape', value: 'landscape'},
    {name : 'restaurant', value: 'restaurant'},
]

function Gallery() {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState(gallery2)
    const [filter, setFilter] = useState('')
    const data  = {
        title : t('main.photoGallery'),
        description: t('main.photoGalleryDesc'),
        navigation: [{path: '/gallery', title: t('main.gallery')}]
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function galleryItem2(item:Image) {
        let customClass = ''
        item.category.forEach(element => {
            customClass += ` ${element}`
        });
        return(
            <div className={`${customClass}`}>
                <a data-fancybox="gallery" href={item.path} className="knsl-gallery-item">
                    <img src={item.path} alt={item.title} />
                    <span className="knsl-zoom"><i className="fas fa-search-plus"></i></span>
                </a>
            </div>
        )
    }

    function filterItem(category:Category) {
        return(
            <a key={category.value} href="/gallery#" onClick={evt => changeFilter(category.value)} data-filter={`.${category.value}`}  className={filter===category.value?"knsl-work-category knsl-current":"knsl-work-category"}>{t(`main.${category.name}`)}</a>
        )
    }

    function changeFilter(data:string) {
        let filtersData = gallery2
        if(data!=='')
            filtersData = gallery2.filter((item => item.category.includes(data)))
        setFilter(data)
        setFilterData(filtersData)
    }

    return (
        <>
            <Banner data={data} />

            <div className="knsl-p-100-100">
                <div className="container">
                    <div className="knsl-filter knsl-mb-60">
                        <a href="/gallery#" data-filter="*" onClick={evt => changeFilter("")} className={filter===''?"knsl-work-category knsl-current":"knsl-work-category"}>{t('main.allPhotos')}</a>
                        {categories.map((category:Category) => filterItem(category))}
                    </div>

                    <Masonry
                        breakpointCols={3}
                        className="knsl-masonry-grid"
                        columnClassName="knsl-masonry-grid-item">
                        {filterData.map((item:Image) => galleryItem2(item))}
                    </Masonry>
                </div>
                </div>
        </>
    )
}

export default Gallery